// export const HOLIDAYLIST_IMG_URL = 'https://drive.google.com/thumbnail?id=19HbphVbW_w-56eIbRMyDqEXXses1qFTX&sz=w2000';
// export const QUARTERLY_GOAL_IMG_URL = 'https://drive.google.com/thumbnail?id=19HbphVbW_w-56eIbRMyDqEXXses1qFTX&sz=w2000';

export const HOLIDAYLIST_IMG_URL = '/assets/images/Holiday2025.webp';
export const QUARTERLY_GOAL_IMG_URL = '/assets/images/Quarterlygoal.webp';